<template>
  <div
    class="video-loading"
    :style="!$store.state.isShowShopping ? '':'opacity: 0'"
  >
    <div class="bar"></div>
  </div>
</template>
<script>
export default {
  name: 'videoLoading',
};
</script>
<style lang="less" scoped>
@keyframes videoLoading {
  0% {
    width: 0%;
    background: rgba(128, 128, 128, 1);
  }
  25% {
    width: 25%;
    background: rgba(128, 128, 128, 0.75);
  }
  50% {
    width: 50%;
    background: rgba(128, 128, 128, 0.5);
  }
  75% {
    width: 75%;
    background: rgba(128, 128, 128, 0.25);
  }
  100% {
    width: 100%;
    background: rgba(128, 128, 128, 0.25);
  }
}
.video-loading {
  width: 100%;
  height: 1px;
  margin: 0 auto;
  position: relative;
  .bar {
    animation: videoLoading 0.5s infinite;
    position: absolute;
    width: 0%;
    height: 100%;
    background: rgba(128, 128, 128, 1);
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 999999999999;
  }
}
</style>
